import React from 'react'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

type AgencySubNavigationProps = {
  agencyID?: number
  /**
   * Resolved by the page, which needs it for the document title anyway. Passing it down keeps a
   * single owner of the lookup, so a cold agency page does not fetch the profile twice.
   */
  agencyName?: string
}

export const AgencySubNavigation = ({ agencyID, agencyName }: AgencySubNavigationProps) => (
  <SubNavigation subPage="agencies" data={{ agencyID, agencyName }} data-testid="agency-sub-nav" />
)
